import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  HOME,
  POLICY,
  ELIGIBLE_PRODUCT,
  useEligibilityContext,
  ELIGIBILITY_STATUS,
  useProcessPathPairsContext,
} from "../shared";
import HomeIndex from "../pages/home/homeIndex";
import PolicyIndex from "../pages/policy/policyIndex";
import EligibleProductIndex from "../pages/eligibleProduct/eligibleProductIndex";
import { Navigate } from "react-router-dom";

const MainContent = () => {
  const { hasConfirmedEligibility } = useEligibilityContext();
  const { processPathPairs } = useProcessPathPairsContext();
  const isSiteEligible = processPathPairs.length !== 0;

  return (
    <Routes>
      <Route path={HOME} element={<HomeIndex></HomeIndex>} />
      <Route
        path={ELIGIBLE_PRODUCT}
        element={
          hasConfirmedEligibility !== ELIGIBILITY_STATUS.YES ? (
            <Navigate to={HOME} />
          ) : (
            <EligibleProductIndex></EligibleProductIndex>
          )
        }
      />
      <Route
        path={POLICY}
        element={
          isSiteEligible ? <PolicyIndex></PolicyIndex> : <Navigate to={HOME} />
        }
      />
    </Routes>
  );
};

export default MainContent;
